import { ScheduleImpactStates } from "constants/index";
import { ImpactSummaryDataType } from "./model";
import "./sch-impact-summary-table.scss";

function ScheduleImpactSummary(props: {
  scheduleImpactSummary: ImpactSummaryDataType;
}) {
  const { scheduleImpactSummary } = props;
  return (
    <div
      className="w-[80%] mx-auto mt-5 pt-3 bg-white rounded-lg"
      style={{ border: "1px solid rgba(156, 163, 175, 0.2)" }}
    >
      <div
        className="font-semibold text-lg mb-1 pb-2 pl-4"
        data-testid="summary-header"
      >
        Summary
      </div>
      <div className="overflow-x-auto">
        <table
          className="min-w-full text-sm text-left"
          data-testid="impact-summary-table"
        >
          <tr
            className="bg-gray-50 text-gray-500"
            style={{
              borderTop: "thin solid rgba(156, 163, 175, 0.2)",
              borderBottom: "thin solid rgba(156, 163, 175, 0.2)"
            }}
            data-testid="table-headers-row"
          >
            <th
              className="py-3 px-4 font-medium"
              data-testid="type-of-change-header"
            >
              Type of Change
            </th>
            <th
              className="py-3 px-4 font-medium"
              data-testid="total-activities-header"
            >
              Total No. of Activities
            </th>
            <th
              className="py-3 px-4 font-medium"
              data-testid="procurement-activities-header"
            >
              Activities tied to Procurement
            </th>
            <th
              className="py-3 px-4 font-medium"
              data-testid="impacted-submittals-header"
            >
              Impacted Submittals
            </th>
            <th
              className="py-3 px-4 font-medium"
              data-testid="impacted-materials-header"
            >
              Impacted Materials
            </th>
          </tr>
          <tbody>
            <tr
              style={{ borderBottom: "thin solid rgba(156, 163, 175, 0.2)" }}
              data-testid="updated-activities-row"
            >
              <td className="py-3 px-4" data-testid="updated-type-cell">
                {ScheduleImpactStates.ACTIVITIES_UPDATED}
              </td>
              <td
                className="py-3 px-4"
                data-testid="updated-total-activities-cell"
              >
                {scheduleImpactSummary?.totalNoOfActivities?.updated}
              </td>
              <td
                className="py-3 px-4"
                data-testid="updated-procurement-activities-cell"
              >
                {scheduleImpactSummary?.activitiesTiedToProcurement?.updated}
              </td>
              <td
                className="py-3 px-4"
                data-testid="updated-impacted-submittals-cell"
              >
                {scheduleImpactSummary?.impactedSubmittals?.updated}
              </td>
              <td
                className="py-3 px-4"
                data-testid="updated-impacted-materials-cell"
              >
                {scheduleImpactSummary?.impactedMaterials?.updated}
              </td>
            </tr>
            <tr
              style={{ borderBottom: "thin solid rgba(156, 163, 175, 0.2)" }}
              data-testid="deleted-activities-row"
            >
              <td className="py-3 px-4" data-testid="deleted-type-cell">
                {ScheduleImpactStates.ACTIVITIES_DELETED}
              </td>
              <td
                className="py-3 px-4"
                data-testid="deleted-total-activities-cell"
              >
                {scheduleImpactSummary?.totalNoOfActivities?.deleted}
              </td>
              <td
                className="py-3 px-4"
                data-testid="deleted-procurement-activities-cell"
              >
                {scheduleImpactSummary?.activitiesTiedToProcurement?.deleted}
              </td>
              <td
                className="py-3 px-4"
                data-testid="deleted-impacted-submittals-cell"
              >
                {scheduleImpactSummary?.impactedSubmittals?.deleted}
              </td>
              <td
                className="py-3 px-4"
                data-testid="deleted-impacted-materials-cell"
              >
                {scheduleImpactSummary?.impactedMaterials?.deleted}
              </td>
            </tr>
            <tr data-testid="added-activities-row">
              <td className="py-3 px-4" data-testid="added-type-cell">
                {ScheduleImpactStates.ACTIVITIES_ADDED}
              </td>
              <td
                className="py-3 px-4"
                data-testid="added-total-activities-cell"
              >
                {scheduleImpactSummary?.totalNoOfActivities?.added}
              </td>
              <td
                className="py-3 px-4"
                data-testid="added-procurement-activities-cell"
              >
                {scheduleImpactSummary?.activitiesTiedToProcurement?.added}
              </td>
              <td
                className="py-3 px-4"
                data-testid="added-impacted-submittals-cell"
              >
                {scheduleImpactSummary?.impactedSubmittals?.added}
              </td>
              <td
                className="py-3 px-4"
                data-testid="added-impacted-materials-cell"
              >
                {scheduleImpactSummary?.impactedMaterials?.added}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ScheduleImpactSummary;
